// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@guestsupply/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { addressBookStyles } from "@guestsupply/Overrides/Widgets/Addresses/AddressBook";
import { color, createLinkIconStyles, mergeWithCss } from "@guestsupply/XDL/Utilities";
import Edit from "@insite/mobius/Icons/Edit";
import { css } from "styled-components";

addressBookStyles.addressCard = {
    actionUseAsShippingAddressButton: {
        variant: "secondary",
        css: css`
            min-width: 200px;
        `,
    },
    actionEditLink: {
        ...createLinkIconStyles(Edit, {
            typographyProps: {
                size: 12,
            },
            icon: {
                iconProps: {
                    size: 13,
                    color: "primary",
                    css: css`
                        margin-right: 4px;
                        opacity: 0.33;
                    `,
                },
                position: "left",
            },

            css: css`
                display: flex;
                justify-content: center;
                margin-top: 15px;
                margin-inline: auto;
            `,
        }),
    },
    gridContainer: { gap: 20 },
    addressInfoDisplayGridItem: { width: [10, 10, 5, 7, 7] },
    actionsGridItem: {
        width: [2, 2, 7, 5, 5],
        css: css`
            justify-content: flex-end;
        `,
    },
    bottomBorderGridItem: { width: 12 },
    bottomBorder: {
        css: css`
            height: 1px;
            background-color: ${color("common.border")};
            width: 100%;
        `,
    },
};

addressBookStyles.noAddressesText = { ...dataTableStyles.noResultsText };

addressBookStyles.centeringWrapper = {
    css: css`
        height: 300px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    `,
};
// XNG-Changes: GSS-355
addressBookStyles.addressFormModal = {
    sizeVariant: "large",
};
